import { render, staticRenderFns } from "./stage3.vue?vue&type=template&id=5a33cea4&"
import script from "./stage3.vue?vue&type=script&lang=js&"
export * from "./stage3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports